import { GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const icing: Palette[] = [
    {
        name: 'Icing',
        id: GDFPalletCode.icing_new,
        type: 'categorical',
        entries: [
            {
                label: '',
                color: '#000000',
                hide: true
            },
            {
                label: 'Trace',
                color: '#D2FFFF'
            },
            {
                label: 'Light',
                color: '#96D2FF'
            },
            {
                label: 'Moderate',
                color: '#6496FA'
            },
            {
                label: 'Heavy',
                color: '#3232FF'
            }
        ]
    },
    {
        name: 'Enhanced Icing',
        id: GDFPalletCode.sehzd_icing,
        type: 'categorical',
        entries: [
            {
                label: '',
                color: '#000000',
                hide: true
            },
            {
                label: 'Slight',
                color: '#99CCFF'
            },
            {
                label: 'Moderate',
                color: '#3399FF'
            },
            {
                label: 'Severe',
                color: '#0000FF'
            }
        ]
    },
    {
        id: GDFPalletCode.vec_hiwc,
        name: 'HIWC Icing',
        type: 'categorical',
        entries: [
            {
                label: '',
                color: '#000000',
                hide: true
            },
            {
                label: 'Light',
                color: '#1EE6FF'
            },
            {
                label: 'Moderate',
                color: '#0083FF'
            },
            {
                label: 'Severe',
                color: '#0000FF'
            }
        ]
    },
    {
        id: GDFPalletCode.hiwc,
        name: 'HIWC Icing',
        type: 'categorical',
        entries: [
            {
                label: '',
                color: '#000000',
                hide: true
            },
            {
                label: 'Low',
                color: '#0000FF'
            },
            {
                label: 'Medium',
                color: '#0083FF'
            },
            {
                label: 'High',
                color: '#1EE6FF'
            }
        ]
    }
];
